import { InviteUserToProjectResponse } from '@monorepo/shared/apiClient/users';
import PendoManager from '@monorepo/old-web/js/managers/pendoManager';
import truncate from 'lodash.truncate';
import { ProjectPermissionRoles, isValidEmailAddress } from 'mapistry-shared';
import {
  compose,
  isRequired as isRequiredValidator,
} from '@monorepo/shared/utils/validators';

export const SUCCESS_TOAST_DURATION_MS = 30 * 1000;

// Orgs can have tens of thousands of users; cap how many the dropdown renders
// at once so the typeahead stays responsive.
export const MAX_RENDERED_EMAIL_OPTIONS = 50;

export const INVITE_CARRIER_PIGEON_ERROR =
  "Oh no! Our carrier pigeon couldn't deliver your invite. Please try again later or contact Mapistry customer service.";

// Users invited without a name are stored as "Invited User (their@email.com)",
const PLACEHOLDER_NAME_PREFIX = 'Invited User';
export function hasPlaceholderName(name: string): boolean {
  return name.startsWith(PLACEHOLDER_NAME_PREFIX);
}

/** Display as "Name (email)"; placeholder names already include the email. */
export function formatUserNameWithEmail(name: string, email: string): string {
  return hasPlaceholderName(name) ? name : `${name} (${email})`;
}

const isEmailFormat = (value?: unknown) => {
  const trimmed = (value ?? '').toString().trim();
  if (!trimmed) return undefined;
  return isValidEmailAddress(trimmed) ? undefined : 'Invalid email address';
};

export const emailValidator = compose(isRequiredValidator, isEmailFormat);

export const EMAIL_INVITE_PENDO_EVENT = 'Email_Invite';

type EmailInvitePendoMetadata = {
  id: string;
  userName: string;
  userRole: ProjectPermissionRoles;
  userEmail: string;
  projectId: string;
  projectName: string;
};

function getProjectDisplayNameForPendo(projectName: string) {
  return truncate(projectName, { length: 25 });
}

export function trackEmailInviteInPendo({
  inviteResult,
  userName,
  userRole,
  userEmail,
  projectId,
  projectName,
}: {
  inviteResult: InviteUserToProjectResponse;
  userName: string;
  userRole: ProjectPermissionRoles;
  userEmail: string;
  projectId: string;
  projectName: string;
}) {
  const metadata: EmailInvitePendoMetadata = {
    id: inviteResult.id,
    userName,
    userRole,
    userEmail,
    projectId,
    projectName: getProjectDisplayNameForPendo(projectName),
  };
  PendoManager.trackCustomEvent(EMAIL_INVITE_PENDO_EVENT, metadata);
}
